import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Motorista } from "./motorista.model";
import { apiName } from "./data.service";

@Injectable()
export class MotoristaApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Motorista, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Motorista, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"include":[{"funcionario":["pessoa"]},"categoriaCnh"]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":[{"funcionario":["pessoa"]},"categoriaCnh"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/shared/motorista-api.service.ts
 **/